import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Team_user_documents(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    
  const imgpath = 'https://dmsapi.businesssamadhan.in/public/';
    
    
 //description hide overflow 
 const MAX_LENGTH = 50;
 const [showFullDescIndex, setShowFullDescIndex] = useState(null);


 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");


{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
{/* const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 */}





//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);



 //Error Variable
 const[errorvar,seterrorvar] = useState();


 //FILTER VARIABLES
//filter_val
const[filterval,setfilterval]=useState(0);

const[filter_document_id,setfilter_document_id]=useState();const updatefilter_document_id = (event) => { setfilter_document_id(event.target.value);}; const[filter_document_id_er,setfilter_document_id_er]=useState();
const[filter_document_name,setfilter_document_name]=useState();const updatefilter_document_name = (event) => { setfilter_document_name(event.target.value);}; const[filter_document_name_er,setfilter_document_name_er]=useState();
const[filter_project_name,setfilter_project_name]=useState();const updatefilter_project_name = (event) => { setfilter_project_name(event.target.value);}; const[filter_project_name_er,setfilter_project_name_er]=useState();
const[filter_project_type,setfilter_project_type]=useState();const updatefilter_project_type = (event) => { setfilter_project_type(event.target.value);}; const[filter_project_type_er,setfilter_project_type_er]=useState();
const[filter_document_type,setfilter_document_type]=useState();const updatefilter_document_type = (event) => { setfilter_document_type(event.target.value);}; const[filter_document_type_er,setfilter_document_type_er]=useState();
const[filter_document_category,setfilter_document_category]=useState();const updatefilter_document_category = (event) => { setfilter_document_category(event.target.value);}; const[filter_document_category_er,setfilter_document_category_er]=useState();
const[filter_updated_by,setfilter_updated_by]=useState();const updatefilter_updated_by = (event) => { setfilter_updated_by(event.target.value);}; const[filter_updated_by_er,setfilter_updated_by_er]=useState();
const[filter_status,setfilter_status]=useState();const updatefilter_status = (event) => { setfilter_status(event.target.value);}; const[filter_status_er,setfilter_status_er]=useState();


//Variables
const[data,setData] = useState([]);//SetData Variable

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


 useEffect(()=>{
   
  getData();
  
  },[])
 





//******************* GET TEAM MEMBERS DATA FUNCTION START  ********************//
function getData(){

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("get-user-documents-list", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,

   //Filters
   'Filter_val' :filterval,
   'Filter_document_id' :filter_document_id,
   'Filter_document_name' :filter_document_name,
   'Filter_project_name' :filter_project_name,
   'Filter_project_type' :filter_project_type,
   'Filter_document_type' :filter_document_type,
   'Filter_document_category' :filter_document_category,
   'Filter_updated_by' :filter_updated_by,
   'Filter_status' :filter_status,
   'User_id':sessionStorage.getItem("UserId00"),
   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_document_id_er(response.data.validatorerror.Filter_document_id);
    setfilter_document_name_er(response.data.validatorerror.Filter_document_name);
    setfilter_project_name_er(response.data.validatorerror.Filter_project_name);
    setfilter_project_type_er(response.data.validatorerror.Filter_project_type);
    setfilter_document_type_er(response.data.validatorerror.Filter_document_type);
    setfilter_document_category_er(response.data.validatorerror.Filter_document_category);
    setfilter_updated_by_er(response.data.validatorerror.Filter_updated_by);
    setfilter_status_er(response.data.validatorerror.Filter_status);
    seterrorvar("Validation error!");

  }

  //Data Violation
  if(response.data.error==102){ 
  

     //Setting Filter Violation Errors
     setfilter_document_id_er(response.data.filter_document_id_er);
     setfilter_document_name_er(response.data.filter_document_name_er);
     setfilter_project_name_er(response.data.filter_project_name_er);
     setfilter_project_type_er(response.data.filter_project_type_er);
     setfilter_document_category_er(response.data.filter_document_category_er);
     setfilter_document_type_er(response.data.filter_document_type_er);
     setfilter_updated_by_er(response.data.filter_updated_by_er);
     setfilter_status_er(response.data.filter_status_er);
     seterrorvar("Violation Error");


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }

 }
  
 //******************* GET TEAM MEMBERS DATA FUNCTION END  ********************//

 
 
   

 
return(
    <>
      <Helmet>
            <meta name="robots" content="noindex,nofollow" />
      </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

       

            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">TEAM PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">USER DOCUMENTS </p>
                  </a>
                </div>
                <a href="/teampanel-add-document"><button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                <i className="mdi mdi-plus-circle"></i> Add New Document</button></a>
              </div>
            </div>

            {/*} chart row starts here */}
                     
        
          
          

              {/* TEAMS TABLE SECTION START */}
                  
             <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">User Documents</h4>
                    <p className="card-description">manage documents of <span class="text-primary"><b>{sessionStorage.getItem("HereUser00")}</b></span> from here
                    </p>

                    <code>{error_msg}</code>

{/* FILTER SECTION START */}
<hr/>
<div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
<div class="d-flex justify-content-between">
<div>
<h4 style={{padding:'1rem'}}>Filters</h4>
</div>
<div>

<button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
<i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
</button>
</div>
</div>

<div class="row">
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Document Name</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Document Name" id="filter_document_name" value={filter_document_name} onChange={updatefilter_document_name}  />
<code>{filter_document_name_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Project Name</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Project Name" id="filter_project_name" value={filter_project_name} onChange={updatefilter_project_name}  />
<code>{filter_project_name_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Document Id</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Document Id" id="filter_document_id" value={filter_document_id} onChange={updatefilter_document_id}  />
<code>{filter_document_id_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Project Type</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Project Type" id="filter_project_type" value={filter_project_type} onChange={updatefilter_project_type}  />
<code>{filter_project_type_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Document Type</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Document Type" id="filter_document_type" value={filter_document_type} onChange={updatefilter_document_type}  />
<code>{filter_document_type_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Document Category</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Document Category" id="filter_document_category" value={filter_document_category} onChange={updatefilter_document_category}  />
<code>{filter_document_category_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Document Status</label>
<div class="col-sm-8">
  <select class="form-control" id="filter_document_status" value={filter_status} placeholder="1" onChange={updatefilter_status} style={{padding:"1rem"}}>
  <option value=" ">all</option>
  <option value="public">public</option>
  <option value="private">private</option>
  </select>
  <code>{filter_status_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Updated By</label>
<div class="col-sm-8">
<input type="text" class="form-control" placeholder="Updated By" id="filter_updated_by" value={filter_updated_by} onChange={updatefilter_updated_by}  />
<code>{filter_updated_by_er}</code>
</div>
</div>
</div>
<div class="col-md-6">
<button class="btn btn-primary" onClick={()=>{ setfilterval(1); getData(); }}>Apply Filters</button>
<br/>
<br/>
<br/>
</div>



</div>


<hr/>                  
</div> 

{/* FITER SECTION END */}
                      

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                       
                            
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div className="table-responsive"  id="invoice" ref={componentRef}>
                      <table className="table table-hover table-bordered">
                        <thead>
                           <tr >
                            <th><b>#</b></th>
                            {/*<th style={{fontWeight:"bold"}} hidden={cd_col1_val==1} >Sn</th>*/}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >View/ Download</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Document Id</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Document Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Project Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Project Type</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Document Type</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Document Category</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Remarks</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Status</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Updated By</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1} >Updated At</th>
                           
                            {/*<th  style={{fontWeight:"bold"}} hidden={cd_col11_val==1} ></th>*/}
                          </tr>
                        </thead>
                        <tbody>
                        {
                        
                       data.map((curElm,ind)=>{

                         return(
                         <>
                        <tr key={ind}>
                          <td>{ind + 1}</td>
                          <td><a href={imgpath+curElm.Document_link}  class="btn btn-primary">click here</a></td>          
                          <td>{curElm.Document_id}</td>
                          <td>{curElm.Document_name}</td>
                          <td>{curElm.Project_name}</td>
                          <td>{curElm.Project_type}</td>
                          <td>{curElm.Document_type}</td>
                          <td>{curElm.Document_category}</td>
                         <td style={{ minWidth: "300px", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", lineHeight: "1.5" }}>
                         {curElm.Document_remarks.length > MAX_LENGTH ? (
                         <span>
                         {showFullDescIndex === ind ? curElm.Document_remarks : curElm.Document_remarks.slice(0, MAX_LENGTH) + "... "}
                         <button className="btn btn-link p-0" onClick={() => setShowFullDescIndex(showFullDescIndex === ind ? null : ind)}>
                        {showFullDescIndex === ind ? "Read less" : "Read more"}
                         </button>
                         </span>
                         ) : (
                         curElm.Document_remarks
                         )}
                         </td>
                          <td>{curElm.Document_status}</td>
                          <td>{curElm.Updated_by}</td>
                          <td>{curElm.Date_updated} ({curElm.Time_updated})</td>  
                        </tr>
                        </>
                         )
                         }
                       
                             ) 
                         }
                      
                      
                        </tbody>
                      </table>
                    </div>
                    
                    {/* PAGINATION SECTION START */}
                    <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}
                  </div>
                </div>
              </div>

            {/* CASH TRANSACTIONS TABLE SECTION END */}

          {/*}  <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>
          */}
           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Team_user_documents;